import { FlexDivWrap, ToolbarLabel } from './styles';

import { suggestNewPanelAlignment } from 'store/slices/RoofDataSlice/roofDataSlice';
import { negateEnergyProductionOfPanelsWhichAreStillInEditMode } from 'store/slices/EnergySlice/energySlice';
import { setEditState, setFullScreenState, setSaveWithPanelColorState } from 'store/slices/ToolSlice';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'store';
import { useRefs } from 'contexts/RefContext';
import { useRef } from 'react';
import { resetAllTransformations } from 'components/tool/utils';
import useQueriesRunningInBackGround from 'hooks/useQueriesRunningInBackGround';
import { EnergyState } from 'store/slices/EnergySlice/types';
import { PANEL_OPS, SOLAR_FACET_OPS, ROOF_FACET_OPS } from '../../../../constants';
import { findIntersection } from '../../../../util';
import useEscapeKeyForEditMode from './useEscapeKeyForEditMode';
import { selectIsAnyToolActionActive } from 'store/selectors/toolSelector';
import { selectIsRecomputing } from 'store/slices/DsmShadingSlice/selectors';
export function EditButtonDiv() {

	// useEscapeKeyForEditMode();
	const {
		roofIndexes, editModeEnabled, threeDModelEnabled, userHasModifiedRoofSegs, saveWithPanelColor
	} = useSelector((state: RootState) => state.toolNewPostions.data);
	const { showIrradiance } = useSelector((state: RootState) => state.Irradiance.data);
	const { activePanelMode } = useSelector((state: RootState) => state.panelSlice.data);
	const { roofSegsFromWhichUserHasSelectedPanels, designType } = useSelector((state: RootState) => state.roofData.data);
	const allowedActions = useSelector((state: RootState) => state.roleState.data.allowedActions);
	const { enableEditFacet } = useSelector((state: RootState) => state.roofEditData.data);
	const { activeRoofTool } = useSelector((state: RootState) => state.roofToolLines.data);

	const { annualInputEnergy } = useSelector((state: RootState) => (state.energyData.data ?? {})as EnergyState);
	const dispatch = useDispatch<AppDispatch>();
	const { konvaRef } = useRefs();
	const toggleRef = useRef<HTMLInputElement>(null);
	const queriesRunningInBackGround = useQueriesRunningInBackGround();
	const isAnyActionEnabled = useSelector(selectIsAnyToolActionActive);
	const isRecomputing = useSelector(selectIsRecomputing);
	const someFacetIsStillInEditMode = roofSegsFromWhichUserHasSelectedPanels.filter(ind => roofIndexes.includes(ind));
	const diableEditToggle = queriesRunningInBackGround || threeDModelEnabled || showIrradiance || !!someFacetIsStillInEditMode?.length
	|| activePanelMode || enableEditFacet || activeRoofTool || isAnyActionEnabled || isRecomputing;

	const anyPanelOps = !!findIntersection(PANEL_OPS, allowedActions).length; 
	const anyFacetOps = !!findIntersection((designType === 'SOLAR' ? SOLAR_FACET_OPS : ROOF_FACET_OPS), allowedActions).length;
	if((designType === 'SOLAR') && !anyFacetOps && !anyPanelOps){
		console.log('No facet and panel ops in Solar mode');
		return <></>;
	}
	if((designType !== 'SOLAR') && !anyFacetOps){
		console.log('No facet ops in Roof mode');
		return <></>;
	}
	return (
		<FlexDivWrap>
			<div className='switchButton bg-transparent'>
				<ToolbarLabel className='toolbar-label'>Edit</ToolbarLabel>
     
				<div className="toggle-button-cover">
					<div className="button-cover">
						<div className="button b2" id="button-13">
							<input
								checked={editModeEnabled}
								ref={toggleRef}
								onChange={async () => {
									if (toggleRef.current) {
										const editEnabled = toggleRef.current.checked;
										toggleRef.current.checked = editEnabled;
										dispatch(setEditState({ enabled: editEnabled }));
										dispatch(setSaveWithPanelColorState({ enabled: false }));

										if (!editEnabled && konvaRef?.current && designType === 'SOLAR') {
											if (userHasModifiedRoofSegs) {
												await dispatch(suggestNewPanelAlignment({ energy: annualInputEnergy }));
											}
											dispatch(negateEnergyProductionOfPanelsWhichAreStillInEditMode(roofIndexes));
											resetAllTransformations(konvaRef.current);
										}
										if(editEnabled){
											dispatch(setFullScreenState({ enabled: true}));
											window.parent.postMessage(
												{ id: 'FULL_VIEW_MODE', detail: { fullScreenEnabled: true } },
												'*'
											);
										}
									}
								}}
								type="checkbox"
								className="checkbox"
								disabled={diableEditToggle}
							/>
							<div className="knobs">
								<span></span>
							</div>
							<div className="layer"></div>
						</div>
					</div>
				</div>
			</div>
		</FlexDivWrap>);

}